import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { TextareaModule } from 'primeng/textarea';
import { DocumentReference } from '@angular/fire/firestore';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FirebaseFirestoreService } from '../../../services/firebase.firestore.service';
import { FirebaseStorageService } from '../../../services/firebase.storage.service';
import { CartItem, OrderDetails } from '../../../constants';
import { IftaLabelModule } from 'primeng/iftalabel';
  
@Component({
  selector: 'app-add-shopper-notes-modal-component',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    DialogModule,
    TextareaModule,
    IftaLabelModule
  ],
  templateUrl: './add-shopper-notes-modal-component.component.html',
  styleUrl: './add-shopper-notes-modal-component.component.scss'
})
export class AddShopperNotesModalComponentComponent {
  dynamicDialogRef = inject(DynamicDialogRef);
  dynamicDialogConfig = inject(DynamicDialogConfig);
  firebaseStorageService = inject(FirebaseStorageService);
  firebaseFirestoreService = inject(FirebaseFirestoreService);
  item: CartItem & {orderId: string, orderRef: DocumentReference, orderNumber: string} = {} as CartItem & {orderId: string, orderRef: DocumentReference, orderNumber: string};
  shopperNotes: string = '';
  order: OrderDetails = {} as OrderDetails;
  constructor() {
    this.item = this.dynamicDialogConfig.data.item;
    this.shopperNotes = this.item.shopperNotes || '';
    // get order details
    this.firebaseFirestoreService.getOrderDetails(this.item.orderRef as DocumentReference).then((order: OrderDetails | undefined) => {
      this.order = order || {} as OrderDetails;
      this.order.items.forEach((item: CartItem) => {
        if(item.id === this.item.id) {
          this.shopperNotes = item.shopperNotes || '';
        }
      });
    });
  }

  saveNotes() {
    const orderItems = this.order.items;  
    orderItems.forEach((item: CartItem) => {
      if(item.id === this.item.id) {
        item.shopperNotes = this.shopperNotes;
      }
    });
    this.firebaseFirestoreService.updateOrderDetails(this.item.orderRef as DocumentReference, {items: orderItems});
    this.dynamicDialogRef.close(this.shopperNotes);
  }

  close() {
    this.dynamicDialogRef.close();
  }

}
